webpackJsonp([8],{

/***/ 1285:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextFields = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(14);

var _materialish = __webpack_require__(59);

__webpack_require__(1285);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextFields = exports.TextFields = function (_Component) {
  _inherits(TextFields, _Component);

  function TextFields() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TextFields);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextFields.__proto__ || Object.getPrototypeOf(TextFields)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      field: 'Paris, France',
      input: '',
      textarea: ''
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TextFields, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var component = this.props.component;
      var materialDocsLink = component.materialDocsLink;
      var _state = this.state,
          input = _state.input,
          field = _state.field,
          textarea = _state.textarea;


      return _react2.default.createElement(
        'div',
        { className: 'componentDoc' },
        _react2.default.createElement(
          'h1',
          { className: 'primaryHeader componentDoc_primaryHeader' },
          'Text Fields'
        ),
        _react2.default.createElement(
          'p',
          { className: 'paragraph' },
          'Text fields let users enter and edit text.'
        ),
        _react2.default.createElement(
          _materialish.Table,
          { className: 'componentDoc_componentsTable' },
          _react2.default.createElement(
            _materialish.Table.Head,
            null,
            _react2.default.createElement(
              _materialish.Table.HeadRow,
              null,
              _react2.default.createElement(
                _materialish.Table.HeadCell,
                { width: '270px' },
                'Preview'
              ),
              _react2.default.createElement(
                _materialish.Table.HeadCell,
                { width: '150px' },
                'Name'
              ),
              _react2.default.createElement(
                _materialish.Table.HeadCell,
                null,
                'Description'
              )
            )
          ),
          _react2.default.createElement(
            _materialish.Table.Body,
            null,
            _react2.default.createElement(
              _materialish.Table.Row,
              null,
              _react2.default.createElement(
                _materialish.Table.Cell,
                null,
                _react2.default.createElement(
                  _materialish.Field,
                  { required: true },
                  _react2.default.createElement(
                    _materialish.Field.Label,
                    null,
                    'Place of Residence'
                  ),
                  _react2.default.createElement(_materialish.Field.Input, {
                    error: true,
                    value: field,
                    onChange: function onChange(e) {
                      return _this2.setState({ field: e.target.value });
                    },
                    className: 'textFields_exampleField'
                  }),
                  _react2.default.createElement(
                    _materialish.Field.ErrorMessage,
                    null,
                    'Invalid place of residence.'
                  )
                )
              ),
              _react2.default.createElement(
                _materialish.Table.Cell,
                null,
                _react2.default.createElement(
                  _reactStatic.Link,
                  { to: '/components/field' },
                  'Field'
                )
              ),
              _react2.default.createElement(
                _materialish.Table.Cell,
                null,
                'provides a text input, label, and error message'
              )
            ),
            _react2.default.createElement(
              _materialish.Table.Row,
              null,
              _react2.default.createElement(
                _materialish.Table.Cell,
                null,
                _react2.default.createElement(_materialish.Input, {
                  value: input,
                  onChange: function onChange(e) {
                    return _this2.setState({ input: e.target.value });
                  },
                  className: 'textFields_exampleInput'
                })
              ),
              _react2.default.createElement(
                _materialish.Table.Cell,
                null,
                _react2.default.createElement(
                  _reactStatic.Link,
                  { to: '/components/input' },
                  'Input'
                )
              ),
              _react2.default.createElement(
                _materialish.Table.Cell,
                null,
                'a standalone text input, for when you do not need a label or error message'
              )
            ),
            _react2.default.createElement(
              _materialish.Table.Row,
              null,
              _react2.default.createElement(
                _materialish.Table.Cell,
                null,
                _react2.default.createElement(_materialish.TextArea, {
                  value: textarea,
                  onChange: function onChange(e) {
                    return _this2.setState({ textarea: e.target.value });
                  },
                  style: { width: '230px', minWidth: '230px' }
                })
              ),
              _react2.default.createElement(
                _materialish.Table.Cell,
                null,
                _react2.default.createElement(
                  _reactStatic.Link,
                  { to: '/components/text-area' },
                  'TextArea'
                )
              ),
              _react2.default.createElement(
                _materialish.Table.Cell,
                null,
                'a standalone, multiline text input, for when you do not need a label or error message'
              )
            )
          )
        ),
        _react2.default.createElement(
          'h2',
          { className: 'secondaryHeader componentDoc_standaloneSecondaryHeader' },
          'Useful Links'
        ),
        _react2.default.createElement(
          'ul',
          { className: 'componentDoc_links' },
          _react2.default.createElement(
            'li',
            { className: 'componentDoc_linkItem' },
            _react2.default.createElement(
              'a',
              { href: materialDocsLink, className: 'componentDoc_linkAnchor' },
              _react2.default.createElement('i', { className: 'componentDoc_icon zmdi zmdi-file-text' }),
              ' Material Guidelines'
            )
          )
        )
      );
    }
  }]);

  return TextFields;
}(_react.Component);

exports.default = (0, _reactStatic.withRouteData)(TextFields);

/***/ })

});


// WEBPACK FOOTER //
// templates/src/components/text-fields.3f708756.js